import React, { useState } from 'react'
import LinearProgress from '@mui/material/LinearProgress'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Stack } from '@mui/material'
import { SpacialLogo } from './Svgs'

interface LinearProgressWithLabelProps {
  value: number
}

interface LoadingComponentProps {
  text: string
}

const LinearProgressWithLabel: React.FC<LinearProgressWithLabelProps> = ({
  value,
}) => {
  return (
    <Box sx={{ width: '100%' }}>
      <LinearProgress
        variant='indeterminate'
        // value={value}
        sx={{
          height: '17px',
          borderRadius: '2px',
          background: 'white',
          '& .MuiLinearProgress-bar': {
            background: 'linear-gradient(90deg, #131351 0%, #06F 100%)',
          },
        }}
      />
      {/* <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
        <Typography
          variant='body2'
          color='#3F69FF'
          sx={{ fontSize: '22px' }}
        >{`${Math.round(value)}%`}</Typography>
      </Box> */}
    </Box>
  )
}

const LoadingComponent: React.FC<LoadingComponentProps> = ({ text }) => {
  const [progress, setProgress] = useState<number>(0)

  /*useEffect(() => {
    const timer = setInterval(
      () => {
        setProgress((prevProgress) =>
          prevProgress >= 100 ? 100 : prevProgress + 1,
        )
      },
      loadingTime / 100 - loadingTime / 10000,
    )

    return () => {
      clearInterval(timer)
    }
  }, [loadingTime])*/

  return (
    <Stack
      sx={{
        flex: 1,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
      }}
    >
      <SpacialLogo />
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <img
          src='/images/shapesAnimation.gif'
          alt='shapesAnimation'
          style={{ width: '408px' }}
        ></img>
        <Box sx={{ mt: 3, width: '100%' }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              alignItems: 'center',
            }}
          >
            <Typography
              color='#989898'
              variant='body1'
              sx={{
                fontSize: '16px',
                fontStyle: 'normal',
                lineHeight: 'normal',
                mb: 1,
                display: `${text.length ? 'block' : 'none'}`,
              }}
            >
              {text}
            </Typography>
            <LinearProgressWithLabel value={progress} />
          </Box>
        </Box>
      </Box>
    </Stack>
  )
}

export default LoadingComponent
